<template>

<com-item name="game.peers.experience" :size="size" :loading="loading" :is-empty="!active" title="Rating by Experience">

	<template v-slot:about>

		<p>How ratings change with more plays.</p>

	</template>

	<template v-slot:stats>

		<app-visualisation-segments :data="polar" v-if="active" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	data: function() {

		return {
			ratingColors: {
				0: 'rgba(17, 105, 135, 0.05)',
				1: '#db303b',
				2: '#db303b',
				3: '#df4751',
				4: '#df4751',
				5: '#5369a2',
				6: '#5369a2',
				7: '#1d8acd',
				8: '#2FC482',
				9: '#249563',
				10: '#249563'
			},
			expectedBrackets: ['1', '2', '3', '4-5', '6-7', '8-10', '11-15', '16-20', '21-25', '26-30', '31-40', '41-50', '51-75', '76-100', '101-200', '200+'],
			polar: {
				areas: [
					{ title: '1-5', subtitle: 'plays' },
					{ title: '6-20', subtitle: 'plays' },
					{ title: '21-50', subtitle: 'plays' },
					{ title: '51+', subtitle: 'plays' }
				],
				clickable: false,
				size: 16,
				shades: [
					'rgba(17, 105, 135, 0.2)',
					'rgba(17, 105, 135, 0.4)',
					'rgba(17, 105, 135, 0.6)',
					'rgba(17, 105, 135, 0.8)',
					'rgba(17, 105, 135, 1)'
				],
				segments: [],
				dataset: {
					data: [],
					backgroundColor: []
				}
			}
		}

	},

	computed: {

		loading: function() { return this.fetching === 'all' },

		data: function() { return this.$store.getters['page/insights/game/peers'] },

		active: function() { return this.data && !this.loading && this.data.ratingByPlays && this.data.ratingByPlays.length }

	},

	created: function() { this.visualise() },

	watch: { data: function() { this.visualise() } },

	methods: {

		ratingColor: function(rating) {

			if (!rating) return this.ratingColors[0]
			var band = Math.min(10, Math.max(1, Math.floor(rating)))
			return this.ratingColors[band]

		},

		visualise: function() {

			if (!this.data || !this.data.ratingByPlays || !this.data.ratingByPlays.length) return

			var raw = this.data.ratingByPlays

			// Build bracket map from backend data
			var bracketMap = {}
			for (var r = 0; r < raw.length; r++) {
				bracketMap[raw[r].bracket] = raw[r]
			}

			this.polar.segments = []
			this.polar.dataset.data = []
			this.polar.dataset.backgroundColor = []

			// Always render 16 segments using expected brackets
			for (var i = 0; i < 16; i++) {

				var bracket = this.expectedBrackets[i]
				var item = bracketMap[bracket]
				var rating = item ? item.rating : 0
				var count = item ? item.count : 0

				this.polar.dataset.data.push(rating)
				this.polar.dataset.backgroundColor.push(this.ratingColor(rating))

				var label = rating ? rating.toFixed(1) + ' avg rating' : 'No data'
				label += '<small>' + bracket + ' play' + (bracket === '1' ? '' : 's')
				if (count) label += ' (' + count + ' rater' + (count === 1 ? '' : 's') + ')'
				label += '</small>'

				this.polar.segments.push({ label: label })

			}

		}

	}

}

</script>

<style scoped>
</style>
